var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMobileSignal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 11,
    viewBox: "0 0 17 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 6.66667H2C2.55228 6.66667 3 7.11438 3 7.66667V9.66667C3 10.219 2.55228 10.6667 2 10.6667H1C0.447715 10.6667 0 10.219 0 9.66667V7.66667C0 7.11438 0.447715 6.66667 1 6.66667ZM5.66667 4.66667H6.66667C7.21895 4.66667 7.66667 5.11438 7.66667 5.66667V9.66667C7.66667 10.219 7.21895 10.6667 6.66667 10.6667H5.66667C5.11438 10.6667 4.66667 10.219 4.66667 9.66667V5.66667C4.66667 5.11438 5.11438 4.66667 5.66667 4.66667ZM10.3333 2.33333H11.3333C11.8856 2.33333 12.3333 2.78105 12.3333 3.33333V9.66667C12.3333 10.219 11.8856 10.6667 11.3333 10.6667H10.3333C9.78105 10.6667 9.33333 10.219 9.33333 9.66667V3.33333C9.33333 2.78105 9.78105 2.33333 10.3333 2.33333ZM15 0H16C16.5523 0 17 0.447715 17 1V9.66667C17 10.219 16.5523 10.6667 16 10.6667H15C14.4477 10.6667 14 10.219 14 9.66667V1C14 0.447715 14.4477 0 15 0Z",
    fill: "#060606"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileSignal);
export default __webpack_public_path__ + "static/media/Mobile-Signal.466cd2cca0382f3ef6d1016e076b8ac1.svg";
export { ForwardRef as ReactComponent };